import { render, staticRenderFns } from "./GenericApp.vue?vue&type=template&id=e1236bce"
import script from "./GenericApp.vue?vue&type=script&lang=js"
export * from "./GenericApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports